import { render, staticRenderFns } from "./Accompaniments.vue?vue&type=template&id=5a702c0a&"
import script from "./Accompaniments.vue?vue&type=script&lang=js&"
export * from "./Accompaniments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports